import React, { ReactNode } from "react";

import Image from "../Image";
import Ratio from "../Ratio";

export interface FeaturedHeaderProps {
  image?: string;
  children?: ReactNode;
}

const FeaturedHeader = ({ image, children }: FeaturedHeaderProps) => {
  return (
    <div className="relative flex flex-wrap lg:max-h-screen lg:overflow-hidden lg:flex-no-wrap">
      <div className="w-full bg-gray-100 lg:w-1/2">
        <div className="flex items-center justify-center w-full h-full">
          <div className="mx-8 my-16">{children}</div>
        </div>
      </div>
      <div className="w-full bg-gray-100 lg:w-1/2">
        <Ratio w={16} h={9}>
          <Image src={image} />
        </Ratio>
      </div>
    </div>
  );
};

export default FeaturedHeader;
